import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToastStore } from "../../../core/stores/toast";
import { PageHeader } from "../../../core/components/ui/page-header";
import { ApiError } from "../../../core/lib/api";
import { createCandidate } from "../lib/api";
import { CandidateForm, draftFrom, toInput } from "../components/candidate-form";

export function CandidateNew() {
  const navigate = useNavigate();
  const push = useToastStore((s) => s.push);
  const [busy, setBusy] = useState(false);

  return (
    <div className="page">
      <PageHeader title="Nouveau dossier" subtitle="Création manuelle. Pour partir d'un CV, utilisez « Importer des CV »." />
      <CandidateForm
        initial={draftFrom(null)}
        submitLabel="Créer le dossier"
        busy={busy}
        onCancel={() => navigate("/candidats")}
        onSubmit={async (d) => {
          setBusy(true);
          try {
            const c = await createCandidate(toInput(d));
            push("success", `Dossier ${c.reference} créé`);
            navigate(`/candidats/${c.id}`);
          } catch (e) {
            push("danger", e instanceof ApiError && e.code === "invalid_input" ? "Vérifiez les champs (courriel, dates)." : "Création impossible");
          } finally {
            setBusy(false);
          }
        }}
      />
    </div>
  );
}
